import { Component } from "@angular/core";

import { SvgMixinComponent } from "../svg-mixin.component";

@Component({
  selector: "med-icon-calendar-remove",
  templateUrl: "./med-icon-calendar-remove.component.html",
})
export class MedIconCalendarRemoveComponent extends SvgMixinComponent {}
